import { render, staticRenderFns } from "./PhoneNumberInput.vue?vue&type=template&id=508ae34e&scoped=true&"
import script from "./PhoneNumberInput.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberInput.vue?vue&type=script&lang=js&"
import style0 from "./PhoneNumberInput.vue?vue&type=style&index=0&id=508ae34e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508ae34e",
  null
  
)

export default component.exports